export var getDisplayName = function getDisplayName(WrappedComponent) {
  var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return "TrackEventProvider(".concat(wrappedComponentName, ")");
};
export var assertListeners = function assertListeners() {
  var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return listeners.filter(function (listener) {
    return typeof listener === 'function';
  });
};